// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uh5D","questions":"styles_questions__2mOCQ","footer":"styles_footer__2VAIY"};